function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBondAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    width: 27,
    height: 32,
    viewBox: "0 0 24 24",
    id: "analysis",
    "data-name": "Line Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M21,15l-2.83-2.83M13,10a3,3,0,1,0,3-3A3,3,0,0,0,13,10Zm0,7H7m2-4H7",
    style: {
      fill: "none",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M17,17v3a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3H16",
    style: {
      fill: "none",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBondAnalysis);
export default __webpack_public_path__ + "static/media/BondAnalysis.e5631e244fdbdbef1fb7d1f836f1b5df.svg";
export { ForwardRef as ReactComponent };